import { ReactElement } from 'react';

import { MedicalDeviceOrderStatus } from '@dreryk/egabinet-ezwm-frontend-api';

import { PromiseVoidFunction } from '@dreryk/react-common';
import { Dropdown } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';

type VerifyAgainDropdownItemProps = {
   readonly medicalDeviceOrderStatus: MedicalDeviceOrderStatus;
   readonly sameAsCurrentVisit: boolean;
   readonly onVerifyAgain: PromiseVoidFunction;
};

export const VerifyAgainDropdownItem = (props: VerifyAgainDropdownItemProps): ReactElement | null => {
   const { medicalDeviceOrderStatus, sameAsCurrentVisit, onVerifyAgain } = props;

   if (medicalDeviceOrderStatus !== 'VERIFICATION') {
      return null;
   }

   return (
      <Dropdown.Item
         testId={'verifyAgain'}
         disabled={!sameAsCurrentVisit}
         onClick={async (hide) => {
            try {
               await onVerifyAgain();
            } finally {
               hide();
            }
         }}
      >
         {medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.verifyAgain}
      </Dropdown.Item>
   );
};
